/** Retain a recalled selection only while the exact command token remains in the draft.
 * @param {readonly { command?: import('./commandInvocation.mjs').CommandInvocation }[]} rows
 * @param {string} text
 * @returns {import('./commandInvocation.mjs').CommandInvocation | undefined}
 */
export function recalledCommandForText(rows, text) {
  const selected = rows.length === 1 ? rows[0].command : undefined;
  if (!selected) return undefined;
  const draft = text.trimStart();
  const token = '/' + selected.name;
  if (draft === token) return { name: selected.name };
  if (!draft.startsWith(token) || !/\s/u.test(draft.charAt(token.length))) return undefined;
  return { name: selected.name, args: draft.slice(token.length).trimStart() };
}
